import axios from 'axios'

axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN'
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.headers.post['Content-Type'] = 'application/json'

const httpClient = axios.create({
  baseURL: window._env_.ITP_INVOXIA_WS_HOST,
  timeout: 30000,
  xsrfHeaderName: 'X-CSRFTOKEN',
  xsrfCookieName: 'csrftoken',
  xhrFields: {
    withCredentials: true,
  },
})

const getAuthToken = () => localStorage.getItem('token')

const authInterceptor = (config) => {
  const token = getAuthToken()
  if (!token) return config
  config.headers['Authorization'] = 'Bearer ' + token
  return config
}

httpClient.interceptors.request.use(authInterceptor)

httpClient.interceptors.response.use(
  (response) => {
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },

  (error) => {
    // Callers that render their own failure states opt out of the global redirects (see src/types/axios.d.ts).
    // An invalid session (401) still goes to login.
    if (error.config?.skipErrorRedirect && error.response?.status !== 401) {
      return Promise.reject(error)
    }

    if (error.response == undefined) {
      let vm = window.app
      vm.$router.push('/error')
      return Promise.reject(error)
    }

    const status = error.response.status
    if (status == 403 || status == 401) {
      let vm = window.app
      if (vm.$route.name != '/login') {
        vm.$router.push('/login')
      }
    }
    return Promise.reject(error)
  },
)

export default httpClient
